import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';
import SideNav from 'components/Navigation/SideNav';
import useSideMenuStore from 'store/useSideMenuStore';

import { COLOR_LIGHT_BLUE } from 'constants/colors';
import {
  DESKTOP_SIDEBAR_COLLAPSED_WIDTH_PX,
  DESKTOP_SIDEBAR_EXPANDED_WIDTH_PX,
} from 'constants/sidebarLayout';
import { ParagraphText } from '@urbantxt/paragraph-text';
import useIsMobile from 'hooks/useIsMobile';
import styles from './MainLayout.module.scss';

export type IMenuWrapperProps = {
  children: React.ReactNode;
};

export function MainLayout({ children }: IMenuWrapperProps) {
  const sideMenuIsOpen = useSideMenuStore(s => s.show);
  const toggleSideMenu = useSideMenuStore(s => s.toggle);
  const { isMobile } = useIsMobile();

  const sidebarPad = !isMobile
    ? `${(sideMenuIsOpen
        ? DESKTOP_SIDEBAR_EXPANDED_WIDTH_PX
        : DESKTOP_SIDEBAR_COLLAPSED_WIDTH_PX
      ).toString()}px`
    : '0px';

  useEffect(() => {
    if (!isMobile || !sideMenuIsOpen) {
      return undefined;
    }
    const { documentElement: html, body } = document;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
    };
  }, [isMobile, sideMenuIsOpen]);

  return (
    <div>
      <header className={styles.mobileHeader}>
        <button
          type="button"
          className={clsx(styles.iconButton, styles.mobileHamburger)}
          aria-label="Open menu"
          onClick={toggleSideMenu}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
        <NavLink className={styles.brandLink} end to="/">
          <ParagraphText
            fontSize={18}
            marginRight={2}
            marginTop={0}
            marginBottom={0}
            marginLeft={0}
            color={COLOR_LIGHT_BLUE}
            fontWeight={600}
          >
            TXT-
          </ParagraphText>
          <ParagraphText
            margin={0}
            fontSize={18}
            color="#fff"
            fontWeight={600}
          >
            Rosie
          </ParagraphText>
        </NavLink>
      </header>

      <SideNav />

      <div
        className={styles.mainShell}
        style={{ ['--main-layout-sidebar-pad' as string]: sidebarPad }}
      >
        <main className={styles.mainContent}>{children}</main>
      </div>
    </div>
  );
}
